import React from "react";
import RecipeData from "../components/RecipeData";
import Blog from "../components/Blog";
import Subscribe from "../components/Subscribe";
import Testimonial from "../components/Testimonial";

function ElaichiRecipe() {
    let metaTitle = document.getElementById('metatitle');
    let metaKey = document.getElementById('metakey');
    let metaDesc = document.getElementById('metadesc');

    let titleValue = 'Experience the Aromatic Flavor of Ellaichi with Our Instant Drink Premix';
    let keyValue = '100% Natural Ragi Products, Finger Millet Products, Gluten-free Products, Healthy Food Products';
    let descValue = 'No Data Given';

    metaTitle.innerText = titleValue;
    metaKey.setAttribute('content', keyValue);
    metaDesc.setAttribute('content', descValue);

    return (
        <>
            <div id="wrap">

                <RecipeData page="elaichi" />

                <Blog />

                <Subscribe />

                <Testimonial />
            </div>

        </>
    )
}

export default ElaichiRecipe;